
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectAgreementHistoriesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seiyaku"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seiyakuUpdateHistories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seiyaku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seiyaku"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seiyakuUpdateHistories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seiyaku_update_history"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seiyaku"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seiyakuRelation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desiredCondition"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anken_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_kodate_new"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_kodate_old"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_mansion_new"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_mansion_old"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_tochi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_jigyo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientRelation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_client"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name_last"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name_first"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kana_last"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kana_first"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_kana"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":691}};
    doc.loc.source = {"body":"query SelectAgreementHistoriesQuery($seiyaku: Int!) {\n  seiyakuUpdateHistories(seiyaku: $seiyaku) {\n    seiyakuUpdateHistories {\n      seiyaku_update_history\n      seiyaku\n      updatedUser{\n        name\n      }\n      created_at\n      seiyakuRelation {\n        desiredCondition {\n          anken_type\n          kibou_kodate_new\n          kibou_kodate_old\n          kibou_mansion_new\n          kibou_mansion_old\n          kibou_tochi\n          kibou_jigyo\n          clientRelation {\n            company_client\n            name_last\n            name_first\n            kana_last\n            kana_first\n            company_name\n            company_kana\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SelectAgreementHistoriesQuery"] = oneQuery(doc, "SelectAgreementHistoriesQuery");
        
